import { ApplicationRef, ComponentFactoryResolver } from '@angular/core';
var CsAgGridJsAngularCellRenderer = /** @class */ (function () {
    function CsAgGridJsAngularCellRenderer(injector, angularComponent) {
        this.injector = injector;
        this.angularComponent = angularComponent;
    }
    CsAgGridJsAngularCellRenderer.prototype.init = function (params) {
        this.createElement(params);
    };
    CsAgGridJsAngularCellRenderer.prototype.createElement = function (params) {
        if (!this.angularComponent) {
            this.eGui.innerText = params.value; // Fallback if no renderer is provided
            return;
        }
        var factory = this.injector.get(ComponentFactoryResolver).resolveComponentFactory(this.angularComponent);
        var appRef = this.injector.get(ApplicationRef);
        this.componentRef = factory.create(this.injector);
        this.componentRef.instance.params = params;
        appRef.attachView(this.componentRef.hostView);
        this.componentRef.changeDetectorRef.detectChanges();
        this.eGui = this.componentRef.location.nativeElement;
    };
    CsAgGridJsAngularCellRenderer.prototype.getGui = function () {
        return this.eGui;
    };
    CsAgGridJsAngularCellRenderer.prototype.refresh = function (params) {
        if (this.componentRef && this.componentRef.instance) {
            this.componentRef.instance.params = params;
            this.componentRef.changeDetectorRef.detectChanges();
            return true;
        }
        return false;
    };
    CsAgGridJsAngularCellRenderer.prototype.destroy = function () {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    };
    return CsAgGridJsAngularCellRenderer;
}());
export { CsAgGridJsAngularCellRenderer };
